import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { searchAccounts } from '@/Axios/api/accountsManagement';

import {
  createUserGroup,
  deleteUserGroup,
  getAllUserGroups,
  updateUserGroup
} from '../../axios/api/userGroup';
import {
  createUserGroup as createUserGroupAction,
  deleteUserGroup as deleteUserGroupAction,
  fetchUserGroups,
  setUserGroups,
  setUserGroupSearchUsers,
  setUserGroupsError,
  updateUserGroup as updateUserGroupAction,
  userGroupSearchUsers
} from '../slices/UserGroupsSlice';

function* handleFetchUserGroups(
  action: PayloadAction<{ search?: string; page?: number; size?: number } | undefined>,
): SagaIterator {
  try {
    const params = action.payload || {};
    const response = yield call(getAllUserGroups, params);
    yield put(setUserGroups({ data: response.data.data, pagination: response.data.pagination }));
  } catch (e) {
    yield put(setUserGroupsError((e as Error).message || 'Failed to fetch user groups'));
  }
}

function* handleCreateUserGroup(
  action: PayloadAction<{ name: string; description: string }>,
): SagaIterator {
  try {
    yield call(createUserGroup, action.payload);
    yield put(fetchUserGroups());
  } catch (e) {
    yield put(setUserGroupsError((e as Error).message || 'Failed to create user group'));
  }
}

function* handleUpdateUserGroup(
  action: PayloadAction<{ id: number; data: { name: string; description: string } }>,
): SagaIterator {
  try {
    const { id, data } = action.payload;
    yield call(updateUserGroup, id, data);
    yield put(fetchUserGroups());
  } catch (e) {
    yield put(setUserGroupsError((e as Error).message || 'Failed to update user group'));
  }
}

function* handleDeleteUserGroup(action: PayloadAction<number>): SagaIterator {
  try {
    yield call(deleteUserGroup, action.payload);
    yield put(fetchUserGroups());
  } catch (e) {
    yield put(setUserGroupsError((e as Error).message || 'Failed to delete user group'));
  }
}

function* handleSearchUsers(action: PayloadAction<string>): SagaIterator {
  try {
    const response = yield call(searchAccounts, { search: action.payload, page: 0, size: 10 });
    yield put(setUserGroupSearchUsers(response.data.data));
  } catch (e) {
    yield put(setUserGroupsError((e as Error).message || 'Failed to search users'));
  }
}

export function* watchFetchUserGroups() {
  yield takeLatest(fetchUserGroups.type, handleFetchUserGroups);
}
export function* watchCreateUserGroup() {
  yield takeEvery(createUserGroupAction.type, handleCreateUserGroup);
}
export function* watchUpdateUserGroup() {
  yield takeEvery(updateUserGroupAction.type, handleUpdateUserGroup);
}
export function* watchDeleteUserGroup() {
  yield takeLatest(deleteUserGroupAction.type, handleDeleteUserGroup);
}
export function* watchSearchUsers() {
  yield takeLatest(userGroupSearchUsers.type, handleSearchUsers);
}
